import { PropsWithChildren } from 'react'

import { FormProvider } from '@formily/react'

import { GenericalRecord } from '@eastcoal/common/types/utilities'

import { AutoCompleteForm } from './AutoCompleteForm'
import { FormContextProvider } from './Context'
import { FormProps } from './interface'

/**
 * 支持 autoComplete 的表单
 */
export const Form = <T extends GenericalRecord>({
  form,
  onSubmit,
  ...formProps
}: PropsWithChildren<FormProps<T>>) => {
  return (
    <FormProvider form={form}>
      <FormContextProvider>
        <AutoCompleteForm {...formProps} onSubmit={() => onSubmit?.(form)} />
      </FormContextProvider>
    </FormProvider>
  )
}
